const STORAGE_KEY = "uun_saved_items_v1";

// Saved items are only visible to the current browser/device.
// (Privacy-friendly: no tracking, no analytics, no sharing.)
export function getSavedItems() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function addSavedItem(item) {
  const current = getSavedItems();
  const next = [item, ...current].slice(0, 200); // cap to keep storage small
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
}

export function removeSavedItem(id) {
  const current = getSavedItems();
  const next = current.filter((x) => x.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
}

export function clearSavedItems() {
  localStorage.removeItem(STORAGE_KEY);
}
